import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image62 from "../../../../assets/images/Blog63/image62.png";
import image86 from "../../../../assets/images/Blog63/image86.png";
import image80 from "../../../../assets/images/Blog63/image80.png";
import image81 from "../../../../assets/images/Blog63/image81.png";
import image69 from "../../../../assets/images/Blog63/image69.png";
import image33 from "../../../../assets/images/Blog63/image33.png";
import image27 from "../../../../assets/images/Blog63/image27.png";
import image77 from "../../../../assets/images/Blog63/image77.png";
import image75 from "../../../../assets/images/Blog63/image75.png";
import image76 from "../../../../assets/images/Blog63/image76.png";
import image66 from "../../../../assets/images/Blog63/image66.png";
import image85 from "../../../../assets/images/Blog63/image85.png";
import image1 from "../../../../assets/images/Blog63/image1.png";
import image51 from "../../../../assets/images/Blog63/image51.png";
import image28 from "../../../../assets/images/Blog63/image28.png";
import image48 from "../../../../assets/images/Blog63/image48.png";
import image47 from "../../../../assets/images/Blog63/image47.png";
import image89 from "../../../../assets/images/Blog63/image89.png";
import image83 from "../../../../assets/images/Blog63/image83.png";
import image71 from "../../../../assets/images/Blog63/image71.png";
import image63 from "../../../../assets/images/Blog63/image63.png";

const Blog63 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – April 6, 2026</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Grinding Through Uncertainty, Positioning Drives the Tape, Macro Risks Still Linger</p>
        <p>
          Markets enter the week with a more stable tone after the heavy liquidation phase seen through March, but the shift reflects stabilisation following heavy liquidation rather than a clear
          directional change. What initially looked like a recovery has instead evolved into a positioning-driven bounce, where flows are stabilising but conviction remains limited. The move higher
          has lacked follow-through, suggesting that participants are still cautious rather than re-engaging aggressively with risk.
        </p>
        <p>
          Beneath the surface, the adjustment to a supply-driven macro shock continues to shape behaviour. Liquidity conditions remain uneven, with capital concentrating in more liquid areas while
          broader participation lags. The result is a market that feels reactive and sensitive to headlines, where stability exists but is not yet supported by a strong underlying foundation.
        </p>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Stabilisation Driven by Positioning, Not Broad Participation</p>
              <p>
                Equity markets have shown an ability to rebound from oversold conditions, but the nature of the move suggests a positioning-driven recovery rather than a structural shift. The price
                action into the end of last week reflected a familiar pattern — early weakness followed by a squeeze higher as shorts were forced to adjust. This type of behaviour is typically seen
                when positioning becomes stretched, where flows rather than fundamentals drive short-term direction.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image62}
                    alt="daily war trading pattern"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image62)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                The underlying structure, however, remains incomplete. Participation continues to be led by large-cap and liquidity-heavy names, while broader market breadth lags. A significant
                portion of stocks are still trading below key moving averages, reinforcing the idea that the recovery is narrow and lacks depth. This divergence suggests that the market is being
                supported selectively rather than through broad-based demand.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image86}
                    alt="Yardeni sector changes"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image86)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Flows further reinforce this picture. Global equity outflows, particularly from Europe and Japan, have been significant, contributing to their relative underperformance and
                highlighting a lack of sustained conviction outside the most liquid US exposures. This pattern reflects a market where capital is reallocating defensively rather than expanding risk,
                limiting the strength and durability of any upside move.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image80}
                    alt="Europe stock outflows significant"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image80)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image81}
                    alt="Japan equity outflows huge"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image81)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>At the core, markets are being driven by positioning resets and flow adjustments, rather than a clear improvement in macro or earnings visibility.</p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Energy Shock, Rates Pressure, and Policy Constraints</p>
              <p>
                The macro narrative continues to be dominated by energy, with oil remaining the central driver across markets. The sharp move higher reflects ongoing supply constraints and disruption,
                feeding directly into inflation pressures and tightening financial conditions. This is no longer a contained commodity move, but a broader constraint impacting consumption, production,
                and policy flexibility.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image69}
                    alt="oil supply market outcomes"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image69)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt="global pinch points by country on oil supplies"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                The persistence of elevated energy prices is beginning to show through in second-order effects, particularly as higher costs filter into consumption and industrial activity. This
                creates a challenging backdrop where demand faces pressure while inflation remains elevated, reinforcing concerns around a stagflationary environment. The interaction between these
                forces continues to shape market expectations.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image27}
                    alt="diesel nightmare"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image27)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                At the same time, central banks are navigating a difficult balance. Policymakers have signalled caution, particularly around tightening into what is increasingly viewed as a
                supply-driven shock rather than demand-led inflation. This limits the ability of policy to respond aggressively without risking further pressure on growth.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image77}
                    alt="can we really have a hike when seeing a growth slowdown"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image77)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                The result is a policy environment that remains reactive, leaving markets more sensitive to incoming data and external developments rather than guided by clear central bank direction.
              </p>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Supportive, but Increasingly Fragile</p>
              <p>
                While the broader structure shows signs of stabilisation, sentiment and positioning suggest conditions remain stretched. The recent move higher has been driven more by positioning
                dynamics than by a shift in fundamentals, creating a setup where stability may not be durable. This introduces the potential for sharp moves in either direction, depending on how
                narratives evolve.
              </p>
              <p>
                Positioning data highlights a market that is heavily hedged, with strong demand for downside protection. At the same time, realised volatility has not matched the level of protection
                being bought, suggesting an imbalance that can influence short-term price action. This type of setup often leads to reactive moves as hedges are adjusted.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image75}
                    alt="options over-insurance vs reality"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image75)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Short positioning has also increased across both discretionary and systematic strategies, indicating a market that is already leaning defensive. This reflects a market already
                positioned defensively without new catalysts, while also increasing the potential for short-covering moves if sentiment shifts.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image76}
                    alt="peak hedge fund shorts"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image76)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image66}
                    alt="discretionary and systematic inline short now"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image66)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                Sentiment has turned cautious but is not yet at extremes, leaving the market in a middle ground where downside risks remain, but positioning can still drive counter-trend strength. The
                combination of weak breadth and defensive positioning creates a fragile equilibrium rather than a stable trend.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image85}
                    alt="contrarian AAII bearishness"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image85)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Conflicting Signals Beneath Stable Headlines</p>
              <p>
                The past week reflected a stabilisation in price action alongside continued macro uncertainty, with headline data often masking softer underlying trends. While markets attempted to
                find balance, underlying indicators suggested that the adjustment process is still ongoing rather than complete.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br />
                    The latest jobs data delivered a strong headline print, but underlying components pointed to a more mixed picture. Differences between surveys and a decline in labour force
                    participation suggest softer conditions beneath the surface, reinforcing the need to look beyond top-line strength.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image1}
                        alt="blowout NFP headline but downward revisions"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image1)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br />
                    Liquidity dynamics indicate a cautious stance, with flexibility being preserved rather than aggressively deployed. This reflects uncertainty around growth conditions and a
                    preference to maintain optionality in the current environment.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image51}
                        alt="China withdraws liquidity for a rainier day"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image51)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br />
                    Corporate expectations remain relatively stable, but valuation compression suggests markets are adjusting to macro risks rather than reacting to a deterioration in fundamentals.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities:</span>
                    <br />
                    Energy and refined product markets continue to reflect tight supply conditions, with disruptions forcing rerouting and increasing pricing pressure across key inputs. These dynamics
                    highlight the ongoing influence of supply-side constraints.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image27}
                        alt="diesel nightmare"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image27)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image28}
                        alt="diesel supplies being re-routed to higher prices"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image28)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>
                    <br />
                    Digital assets have shown relative resilience, with flows suggesting shifting liquidity dynamics rather than a clear macro-driven trend. The divergence reflects changing
                    positioning rather than strong directional conviction.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image48}
                        alt="gold and BTC flip flop flows"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image48)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image47}
                        alt="Bitcoin holding its power law curve"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image47)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br />
                    Oil remains central to the macro narrative, with supply constraints and geopolitical developments continuing to drive price action and influence broader market expectations.
                  </p>
                  <div
                    className="imageWrapperCont"
                    style={{marginTop: "22px"}}
                  >
                    <div className="relatedImg">
                      <img
                        src={image33}
                        alt="global pinch points by country on oil supplies"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image33)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt="zoom"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Key Data and Market-Moving Signals</p>
              <p>
                The week ahead is dense with macro catalysts, even without the geopolitical backdrop. Markets will be balancing growth, inflation, and policy signals alongside energy dynamics and bond
                market movements. With positioning already stretched and sensitivity to headlines elevated, incoming data is likely to have an amplified impact on price action.
              </p>

              <p className="highlightedText">Monday, April 6</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> ISM Non-Manufacturing PMI, Prices, Employment
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> CB Employment Trends Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">IN:</span> HSBC Manufacturing & Services PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global:</span> Holiday-thinned liquidity across major regions (Easter, Ching Ming Festival)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EU:</span> Spain Unemployment Change
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, April 7</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Durable Goods Orders
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> GDPNow Update
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Consumer Credit
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> IBD/TIPP Economic Optimism
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> NY Fed 1-Year Inflation Expectations
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> EIA Short-Term Energy Outlook
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Global:</span> Final Services & Composite PMIs (EU, UK, Japan, Australia)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">JP:</span> Household Spending, Wage Data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> 3-Year Note Auction
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, April 8</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> FOMC Meeting Minutes
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">IN:</span> Interest Rate Decision
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">NZ:</span> Interest Rate Decision + Press Conference
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> MBA Mortgage Applications, Mortgage Rates
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EU:</span> Retail Sales, PPI Data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EU:</span> Construction PMIs
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> 10-Year Note Auction
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, April 9</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> PCE Inflation Data (Core + Headline)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Q4 GDP (Final), GDP Price Index
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Jobless Claims (Initial & Continuing)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Personal Spending, Income, Real Consumption
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Corporate Profits
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Wholesale Inventories & Trade Sales
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Fed Balance Sheet, Reserve Balances
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">EU:</span> German Industrial Production, Trade Balance
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">JP:</span> Household Confidence
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> 30-Year Bond Auction
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, April 10</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> CPI Inflation Data (Core + Headline)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Michigan Consumer Sentiment, Current Conditions
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Michigan Inflation Expectations (1Y & 5Y)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US:</span> Real Earnings
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CA:</span> Employment Data, Unemployment Rate
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CN:</span> CPI & PPI Data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">JP:</span> PPI Data
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">KR:</span> Interest Rate Decision
                  </p>
                </li>
              </ul>

              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image89}
                    alt="EW060426"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image89)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Positioning Supportive, Macro Still Unresolved</p>
              <p>
                Markets are navigating a phase in which positioning dynamics and macro uncertainty interact in real time, creating a stable yet fragile environment. The shift away from aggressive
                de-risking has improved short-term stability, but the balance between positioning support and unresolved macro risks remains delicate.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br />
                    Markets have stabilised from oversold conditions, but participation remains narrow with large-cap leadership masking weaker breadth underneath. Price action continues to reflect a
                    positioning-driven recovery, where rallies are supported by short covering rather than broad conviction.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span>
                    <br />
                    Gold has not behaved in line with traditional geopolitical expectations, reflecting its role as a source of liquidity rather than a pure haven. Recent weakness suggests capital is
                    being raised, even as the broader trend remains intact.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br />
                    Crypto continues to reflect shifting liquidity dynamics, showing relative resilience compared to traditional assets. Price action appears driven more by flows than macro alignment,
                    highlighting evolving rather than expanding participation.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro:</span>
                    <br />
                    Energy remains the dominant driver, with elevated oil prices feeding into inflation pressures and weighing on growth expectations. At the same time, labour signals remain mixed and
                    policy cautious, leaving markets reactive to data and geopolitical developments.
                  </p>
                </li>
              </ul>
              <p className="highlightedText">
                There are conditions for a counter-trend consolidation rally, with positioning stretched and markets already leaning defensive. That said, the environment remains headline-driven, with
                energy, rates, and geopolitics continuing to dictate direction. Trade carefully.
              </p>

              <div
                className="imageWrapperCont"
                style={{marginTop: "22px"}}
              >
                <div className="relatedImg">
                  <img
                    src={image83}
                    alt="BoA bull bear off sell extremes nearer neutral"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image83)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image71}
                    alt="peak put insurance behind us"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image71)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image63}
                    alt="markets do go down 33% of the time"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image63)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt="zoom"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1QA0ULPb3MG3YhHIkaEQterHNR1Pc-X3gl5WEZBrY3VU/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog63;
